import { render, staticRenderFns } from "./OverlayFullScreenVideo.vue?vue&type=template&id=0214d36c&scoped=true"
import script from "./OverlayFullScreenVideo.vue?vue&type=script&lang=js"
export * from "./OverlayFullScreenVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0214d36c",
  null
  
)

export default component.exports